import { render } from "./MovieCont.vue?vue&type=template&id=2f1d2d58&scoped=true"
import script from "./MovieCont.vue?vue&type=script&lang=js"
export * from "./MovieCont.vue?vue&type=script&lang=js"

import "./MovieCont.vue?vue&type=style&index=0&id=2f1d2d58&scoped=true&lang=css"

import exportComponent from "/Users/prateekjha/Projects/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1d2d58"]])

export default __exports__